export interface Roaster {
  id: string;
  username: string;
  displayName: string;
  avatarColor: string;
  initials: string;
  country: string;
  countryCode: string;
  countryFlag: string;
  globalRank: number;
  previousRank: number;
  points: number;
  totalRoasts: number;
  wins: number;
  likes: number;
  winRate: number;
  streak: number;
  badges: Badge[];
  region: string;
}

export interface Badge {
  id: string;
  label: string;
  icon: string;
  color: string;
}

export interface Roast {
  id: string;
  roasterId: string;
  username: string;
  displayName: string;
  avatarColor: string;
  initials: string;
  countryFlag: string;
  country: string;
  text: string;
  category: string;
  votes: number;
  upvotes: number;
  downvotes: number;
  submittedAt: string;
  isRoastOfDay?: boolean;
  isTrending?: boolean;
  tags: string[];
}

export interface CountryRanking {
  rank: number;
  country: string;
  countryCode: string;
  flag: string;
  topRoaster: string;
  totalRoasters: number;
  totalPoints: number;
  wins: number;
  region: string;
}

export const CATEGORIES = [
  { id: 'funniest', label: 'Funniest Roast', icon: '😂', color: '#f59e0b' },
  { id: 'savage', label: 'Most Savage', icon: '🔥', color: '#ef4444' },
  { id: 'comeback', label: 'Best Comeback', icon: '⚡', color: '#8b5cf6' },
  { id: 'one-liner', label: 'Best One-Liner', icon: '🎯', color: '#06b6d4' },
  { id: 'group-destroyer', label: 'Group Chat Destroyer', icon: '💣', color: '#f97316' },
  { id: 'overall', label: 'Best Overall', icon: '👑', color: '#22c55e' },
];

export const REGIONS = [
  { id: 'world', label: 'World' },
  { id: 'europe', label: 'Europe' },
  { id: 'north-america', label: 'North America' },
  { id: 'south-america', label: 'South America' },
  { id: 'asia', label: 'Asia' },
  { id: 'africa', label: 'Africa' },
  { id: 'oceania', label: 'Oceania' },
];

// Points awarded per upvote on a roast
export const POINTS_PER_VOTE = 10;

// Leaderboard starts empty — real users join by submitting roasts and earning votes
export const ROASTERS: Roaster[] = [];

// Roasts start empty — add real entries via the Submit page
export const ROASTS: Roast[] = [];

export const COUNTRY_RANKINGS: CountryRanking[] = [];

export const WEEKLY_LEADERS: (Roaster & { weeklyPoints: number; weeklyWins: number; weeklyRoasts: number })[] = [];
